/* Soie Hand Beauty Journal (2026-10-22): 日本語の文節改行。assets/budoux-ja.min.js の <budoux-ja> で文節境界に U+200B を入れ、
   word-break:keep-all で語の途中で折り返さないようにする(全ブラウザ)。日本語表示のときだけ読み込まれる。 */
(function () {
  if (!document.documentElement || document.documentElement.lang !== 'ja' || !window.customElements || !customElements.get('budoux-ja')) return;
  var ZW = '​', WJ = '⁠';
  var glue = [['」' + ZW + 'は', '」' + WJ + 'は'], ['」' + ZW + 'と', '」' + WJ + 'と'], ['」' + ZW + 'を', '」' + WJ + 'を'], ['」' + ZW + 'の', '」' + WJ + 'の'], ['）' + ZW + 'は', '）' + WJ + 'は'], ['）' + ZW + 'を', '）' + WJ + 'を'], ['）' + ZW + 'の', '）' + WJ + 'の'], ['）' + ZW + 'と', '）' + WJ + 'と']];
  function eachText(el, fn) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false), n, list = [];
    while ((n = w.nextNode())) list.push(n);
    list.forEach(fn);
  }
  var sel = '.sjr-title, .sjr-lead p, .sjr-body p, .sjr-body h2, .sjr-body h3, .sjr-body li, .sjr-related__h, .sjr-nav span, .sji-lead, .sji-h, .sji-x';
  Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
    if (el.getAttribute('data-phrase-wrap')) return;
    el.setAttribute('data-phrase-wrap', '1');
    var b = document.createElement('budoux-ja');
    while (el.firstChild) b.appendChild(el.firstChild);
    el.appendChild(b);
    while (b.firstChild) el.insertBefore(b.firstChild, b);
    el.removeChild(b);
    el.normalize();
    eachText(el, function (n) {
      var v = n.nodeValue;
      glue.forEach(function (g) { v = v.split(g[0]).join(g[1]); });
      if (v !== n.nodeValue) n.nodeValue = v;
    });
    el.style.wordBreak = 'keep-all';
    el.style.overflowWrap = 'anywhere';
  });
})();
